import React from "react";
import { Route, Redirect } from "react-router-dom";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import Loader from "../components/loader";
import { useAuth0 } from "@auth0/auth0-react";
import { toast } from "react-toastify";

let toastOptions = {
  position: "top-right",
  autoClose: 6000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  icon: false,
};

const AdminOrSalesRoute = ({ component, ...args }) => {
  const { user } = useAuth0();
  const userRoles = user && user["https://new.evojets.com/roles"];

  const salesTeam =
    user &&
    userRoles.some(function (role) {
      return (
        "Super Admin" === role ||
        "Account Director" === role ||
        "Sales Assistant" === role ||
        "Account Executive" === role ||
        "Dynamic Sales Assistant" === role
      );
    });

  if (salesTeam) {
    return (
      <Route
        component={withAuthenticationRequired(component, {
          onRedirecting: () => <Loader />,
        })}
        {...args}
      />
    );
  }

  toast.error("Unauthorized!", toastOptions);
  return <Redirect to="/" />;
};

export default AdminOrSalesRoute;
